module.exports = __webpack_public_path__ + "static/media/ducktales.c9d9aedd.mp3";